import React, { useState } from 'react';
import { useRecoilState } from 'recoil';
import { useSnackbar } from 'notistack';
import {
  Button,
  Checkbox,
  TableBody,
  TableCell,
  TableRow
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { createStyles, makeStyles, withStyles } from '@material-ui/core/styles';
import { EditGuestModal } from './EditGuestModal';
import { DeleteGuestModal } from '../parts/cloudStorage/DeleteGuestModal';
import { deleteShareFileGuest } from '../../apicalls/cloud/shareFile';
import { deleteSharePictureGuest } from '../../apicalls/cloud/sharePicture';
import { btnColor } from '../../GlobalState';
import { formatDatetime, checkResData, isTodayAfter } from '../../utils/common';
import { TGuest } from '../../types/cloudStorage/CloudFileList';

type Tprops = {
  guest: TGuest;
  selectedGuestList: TGuest[];
  getSearchedGuestList: () => void;
  addSelectedGuest: () => void;
  removeSelectedGuest: () => void;
  isFileMode: boolean;
};

export const List: React.FC<Tprops> = (props: Tprops) => {
  const {
    guest,
    selectedGuestList,
    getSearchedGuestList,
    addSelectedGuest,
    removeSelectedGuest,
    isFileMode
  } = props;

  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [buttonColor] = useRecoilState(btnColor);

  const [editFolderShareModalOpen, setEditGuestModalOpen] =
    useState<boolean>(false);
  const [openDeleteGuestModal, setOpenDeleteGuestModal] =
    useState<boolean>(false);

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked: boolean = event.target.checked;
    if (checked) {
      addSelectedGuest();
    } else {
      removeSelectedGuest();
    }
  };

  /**
   * 共有先を削除(１件)
   */
  const onDelete = () => {
    if (isFileMode) {
      // 資料の共有先を削除
      deleteShareFileGuest(guest.id)
        .then(resData => {
          checkResData(resData, enqueueSnackbar);
        })
        .then(() => {
          getSearchedGuestList();
        });
    } else {
      // 写真の共有先を削除
      deleteSharePictureGuest(guest.id)
        .then(resData => {
          checkResData(resData, enqueueSnackbar);
        })
        .then(() => {
          getSearchedGuestList();
        });
    }
  };

  return (
    <>
      <TableBody>
        <StyledTableRow className='click_table_row' title=''>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 10 }}
            align='center'
          >
            <Checkbox
              checked={
                selectedGuestList.find(
                  selectedGuest => selectedGuest.id === guest.id
                )
                  ? true
                  : false
              }
              onChange={handleCheck}
              color='default'
            />
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 120 }}
            align='center'
            onClick={() => setEditGuestModalOpen(true)}
          >
            {guest.construct_name}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 120 }}
            align='center'
            onClick={() => setEditGuestModalOpen(true)}
          >
            {guest.name}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 150 }}
            align='center'
            onClick={() => setEditGuestModalOpen(true)}
          >
            {guest.email}
          </StyledTableCell>
          <StyledTableCell
            className={
              isTodayAfter(guest.expiration_at)
                ? classes.table1
                : classes.expiry
            } // 共有期限内か判定してスタイル変更
            style={{ width: 130 }}
            align='center'
            onClick={() => setEditGuestModalOpen(true)}
          >
            {guest.expiration_at === ''
              ? '期限なし'
              : formatDatetime(
                  new Date(guest.expiration_at),
                  'YYYY/MM/DD\nHH:MM:SS'
                )}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 120 }}
            align='center'
            onClick={() => setEditGuestModalOpen(true)}
          >
            {guest.folder_name}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 130 }}
            align='center'
            onClick={() => setEditGuestModalOpen(true)}
          >
            {guest.last_logged_in_at === ''
              ? ''
              : formatDatetime(
                  new Date(guest.last_logged_in_at),
                  'YYYY/MM/DD\nHH:MM:SS',
                  '日本標準時'
                )}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 100 }}
            align='center'
            onClick={() => setEditGuestModalOpen(true)}
          >
            {guest.created_name}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 130 }}
            align='center'
            onClick={() => setEditGuestModalOpen(true)}
          >
            {formatDatetime(
              new Date(guest.created_at),
              'YYYY/MM/DD',
              '日本標準時'
            )}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 100 }}
            align='center'
          >
            <Button
              style={{
                backgroundColor: buttonColor,
                color: '#fff'
              }}
              variant='contained'
              color='secondary'
              onClick={() => setEditGuestModalOpen(true)}
            >
              <EditIcon />
              <span style={{ marginLeft: 4 }}>編集</span>
            </Button>
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 100 }}
            align='center'
          >
            <Button
              style={{
                backgroundColor: buttonColor,
                color: '#fff'
              }}
              variant='contained'
              color='secondary'
              onClick={() => setOpenDeleteGuestModal(true)}
            >
              <DeleteIcon />
              <span style={{ marginLeft: 4 }}>削除</span>
            </Button>
          </StyledTableCell>
        </StyledTableRow>
      </TableBody>

      {/* 共有先詳細表示モーダル */}
      <EditGuestModal
        guest={guest}
        editFolderShareModalOpen={editFolderShareModalOpen}
        setEditGuestModalOpen={setEditGuestModalOpen}
        isFileMode={isFileMode}
        getSearchedGuestList={getSearchedGuestList}
      />

      {/* 共有先削除モーダル */}
      <DeleteGuestModal
        name={guest.name}
        openDeleteGuestModal={openDeleteGuestModal}
        setOpenDeleteGuestModal={setOpenDeleteGuestModal}
        onDelete={onDelete}
      />
    </>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    formControl: {
      minWidth: 120,
      backgroundColor: '#FFFFFF'
    },
    formControl1: {
      minWidth: 120,
      height: 30,
      borderRadius: 5,
      borderWidth: 1,
      paddingLeft: 5
    },
    main: {
      minWidth: 700
    },
    table: {
      backgroundColor: `#999999 !important`,
      color: '#FFFFFF',
      padding: 10,
      fontWeight: 'bold'
    },
    input: {
      borderColor: '#CCCCCC',
      padding: 5,
      margin: 10
    },
    table1: {
      padding: 8,
      wordBreak: 'break-all'
    },
    expiry: {
      padding: 8,
      wordBreak: 'break-all',
      color: 'red'
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 15
    },
    modal: {
      // モーダルを中央に
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    searchBtn: {
      marginBottom: 10,
      marginRight: 20,
      marginLeft: 20,
      backgroundColor: '#52555F'
    },
    tooltip: {
      fontSize: 16
    }
  })
);

// スタイル関係
const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);
